import React, { useState } from 'react'

import { Container, InputContainer, Row } from './styled'
import { Input } from '../../../../components/common/Input'
import { Button } from '../../../../components/common/Button'

export const Status = ({
  data,
  setUnblockModal,
  unblockReason,
  setUnblockReason,
}) => {
  console.log('🚀 ~ data:', data)
  const answered = data.AlwaysAlertMessages.filter(
    (el) => el.answered_at,
  ).length
  const unaswered = data.AlwaysAlertMessages.filter(
    (el) => !el.answered_at,
  ).length

  const blockedUser = data.AlwaysAlertMessages[0].Employee.User.BlockedUsers

  return (
    <Container>
      <Row>
        <InputContainer width="10rem" style={{ alignSelf: 'flex-start' }}>
          <span>Status</span>
          <Button.Root
            backgroundColor={blockedUser.length > 0 ? '#F33C3C' : '#68D873'}
          >
            <Button.Content
              title={blockedUser.length > 0 ? 'Inativo' : 'Ativo'}
              color="#fff"
            />
          </Button.Root>
        </InputContainer>
      </Row>
      <Row>
        <InputContainer>
          <Input.Root>
            <Input.Label title="Alertas enviados" />
            <Input.Wrapper backgroundColor="#f7f7f7" outlineColor="#cecece">
              <Input.Content id="" value={answered} />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
        <InputContainer>
          <Input.Root>
            <Input.Label title="Alertas não respondidos" />
            <Input.Wrapper backgroundColor="#f7f7f7" outlineColor="#cecece">
              <Input.Content value={unaswered} />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
      </Row>
      <Row>
        <InputContainer>
          <Input.Root>
            <Input.Label title="Data do bloqueio" />
            <Input.Wrapper backgroundColor="#f7f7f7" outlineColor="#cecece">
              <Input.Content
                value={
                  blockedUser.length > 0
                    ? new Date(blockedUser[0].blocked_date).toLocaleDateString()
                    : '-'
                }
                readOnly
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
        <InputContainer>
          <Input.Root>
            <Input.Label title="Horário do bloqueio" />
            <Input.Wrapper backgroundColor="#f7f7f7" outlineColor="#cecece">
              <Input.Content
                value={
                  blockedUser.length > 0
                    ? new Date(blockedUser[0].blocked_date).toLocaleTimeString()
                    : '-'
                }
                readOnly
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
      </Row>
      {blockedUser.length > 0 && (
        <Row>
          <InputContainer>
            <span>Comentário pós contato</span>
            <textarea
              value={unblockReason}
              onChange={(e) => setUnblockReason(e.target.value)}
            />
          </InputContainer>
        </Row>
      )}
      {/* <Row>
        <InputContainer>
          <span>Comentário pós contato</span>
          <textarea
            value={unblockReason}
            onChange={(e) => setUnblockReason(e.target.value)}
          />
        </InputContainer>
      </Row> */}
      {blockedUser.length > 0 && (
        <>
          <InputContainer width="fit-content" style={{ alignSelf: 'flex-end' }}>
            <Button.Root
              backgroundColor="#00517D"
              onClick={() => setUnblockModal(true)}
            >
              <Button.Content title="Reativar usuário" color="#fff" />
            </Button.Root>
          </InputContainer>
        </>
      )}
    </Container>
  )
}
